/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Trans, Translation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { jsx, css } from '@emotion/react'
import { get } from 'lodash'
import { Error } from './layout/Error'
import NewPasswordForm from './NewPasswordForm'
import NestedWrappingBusyMask from './NestedWrappingBusyMask'
import { SubmissionError } from '../orm/error'
import { setPassword, isSettingPassword, getLastSettingPasswordError, loggedInUser } from '../actions/auth'
import { default_theme as theme } from '../emotion/theme'
import xoip_logo from '../images/xoip-logo.svg'

class NewPassword extends Component {

    componentDidMount() {
        const { user, history, next } = this.props
        if (user.has_usable_password) {
            // history.reload()
        }
    }

    handleSubmit = (values) => {
        const { next, dispatch, history } = this.props
        const on_done = function() {
            // history.reload()
        }
        
        return dispatch(setPassword(values, on_done))
    }

    render() {
        const { isSaving, lastSettingPasswordError } = this.props
        return (
            <div css={ main }>
              <div css={ container }>
                <div css={ header }>
                  <img src={ xoip_logo } alt="" css={ image } />
                  <p><Trans>Please choose a password</Trans>.</p>
                </div>

                { lastSettingPasswordError &&
                  <Error>
                    <Trans i18nKey={lastSettingPasswordError} />
                  </Error>
                }
                
                <NestedWrappingBusyMask is_loading={isSaving}>
                  <NewPasswordForm onSubmit={ this.handleSubmit } />
                </NestedWrappingBusyMask>
              </div>
            </div>
        )
    }
}
function mapStateToProps(state, props) {
    const user = loggedInUser()
    return {
        user,
        isSaving: isSettingPassword(state),
        lastSettingPasswordError: getLastSettingPasswordError(state)
    }
}
export default withRouter(connect(mapStateToProps)(NewPassword))

const main = css`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color: ${theme.colors.gray2};
min-height: 100vh;
padding: 0 16px;
`

const container = css`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
max-width: 520px;
width: 100%;
background-color: ${theme.colors.white};
box-shadow: 10px 10px 30px 0px #888888;
`

const header = css`
padding-top: 30px;
width: 80%;
text-align: center;
p {
    padding-top: 20px;
}
`

const image = css`
width: 80%;
`
